import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useRevcontentBusinessManagerStore = defineStore({
  id: 'revcontentBusinessManagerStore',
  state: () => ({
    revcontentBusinessManagers: [],
    revcontentBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getRevcontentBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.revcontentBusinessManagersLoading = true

      try {
        const {data} = await axios.get('revcontent/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.revcontentBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.revcontentBusinessManagersLoading = false
      }
    },
  },
})
